import { useContext } from "react";
import AppContext from "../context/AppContext";

export const STEPS = {
  Vehicle: "Vehicle Information",
  Appointment: "Appointment",
  Customer: "Contact Information",
};

export const HASHES = {
  Vehicle: "#vehicle",
  Appointment: "#repairoperations",
  Customer: "#customer",
};

const STEP_KEYS = Object.keys(STEPS);
const STEP_VALUES = Object.keys(STEPS).map((v) => STEPS[v]);

const Stepper = ({ step, pushHash }) => {
  const {
    brand: {
      stepperBackgroundColor,
      stepperTextColor,
      stepperActiveColor,
      stepperActiveTextColor,
    },
  } = useContext(AppContext);

  return (
    <>
      <ol
        className="flex flex-row p-2 bg-slate-200 rounded mb-4"
        style={{
          backgroundColor: stepperBackgroundColor || "",
          color: stepperTextColor || "",
        }}
      >
        {STEP_KEYS.map((key, idx) => {
          return (
            <li
              key={key}
              className={`grow text-l text-center p-2 ${
                STEPS[key] === step ? "bg-white rounded" : ""
              } ${idx < STEP_VALUES.indexOf(step) ? "cursor-pointer" : ""}`}
              style={
                STEPS[key] === step
                  ? {
                      backgroundColor: stepperActiveColor || "",
                      color: stepperActiveTextColor || "",
                    }
                  : {}
              }
              onClick={() => {
                if (idx >= STEP_VALUES.indexOf(step)) {
                  return;
                }
                pushHash(HASHES[key]);
              }}
            >
              <span>{STEPS[key]}</span>
            </li>
          );
        })}
      </ol>
    </>
  );
};

export default Stepper;
